import { render, staticRenderFns } from "./PlanPrice.vue?vue&type=template&id=867aa990&scoped=true&"
import script from "./PlanPrice.vue?vue&type=script&lang=ts&"
export * from "./PlanPrice.vue?vue&type=script&lang=ts&"
import style0 from "./PlanPrice.vue?vue&type=style&index=0&id=867aa990&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867aa990",
  null
  
)

export default component.exports